export const wisesight = {
 "ที่": 10920,
 "ไม่": 10329,
 "ได้": 7626,
 "รับ": 5944,
 "ว่า": 5886,
 "นี้": 5704,
 "การ": 5318,
 "ื่อ": 5292,
 "ให้": 4747,
 "ล้ว": 4504,
 "เป็": 4498,
 "ครั": 4400,
 "แล้": 4359,
 "ป็น": 4331,
 "เลย": 4298,
 "้อง": 4186,
 "กิน": 3957,
 "แต่": 3957,
 "กัน": 3939,
 "ของ": 3727,
 "และ": 3341,
 "มาก": 3283,
 "วัน": 3231,
 "ค่ะ": 3181,
 "กับ": 3085,
 "ประ": 3003,
 "่าง": 2989,
 "ั้ง": 2978,
 "้าง": 2968,
 "มัน": 2814,
 "ใช้": 2737,
 "่อน": 2657,
 "้าน": 2640,
 "อร์": 2512,
 "ต้อ": 2439,
 "ยาก": 2416,
 "ื้อ": 2395,
 "่อย": 2370,
 "กว่": 2368,
 "ตัว": 2340,
 "ควา": 2335,
 "งาน": 2334,
 "้วย": 2318,
 "วาม": 2283,
 "ข้า": 2242,
 "่อง": 2240,
 "ด้ว": 2235,
 "นนี": 2166,
 "น้า": 2162,
 "อยา": 2125,
 "นที": 2112,
 "จาก": 2087,
 "ย่า": 2084,
 "ยัง": 2030,
 "หน้": 2020,
 "แบบ": 1967,
 "ั้น": 1966,
 "เรา": 1923,
 "อย่": 1907,
 "ียร": 1881,
 "ือน": 1867,
 "ทุก": 1863,
 "มือ": 1819,
 "่าน": 1804,
 "ี่ย": 1776,
 "ยร์": 1774,
 "คุณ": 1746,
 "เบี": 1745,
 "อยู": 1712,
 "ยู่": 1708,
 "คือ": 1706,
 "รื่": 1688,
 "น้ำ": 1680,
 "ค้า": 1676,
 "ม่เ": 1673,
 "ร้า": 1667,
 "ม่ไ": 1651,
 "อีก": 1650,
 "บีย": 1649,
 "่ได": 1635,
 "ันน": 1631,
 "สุด": 1630,
 "รือ": 1551,
 "ี่เ": 1545,
 "่มี": 1545,
 "ร้อ": 1536,
 "เข้": 1533,
 "นี่": 1529,
 "ช้า": 1519,
 "หม่": 1514,
 "องเ": 1511,
 "ท่า": 1503,
 "ราค": 1495,
 "เอา": 1490,
 "ลือ": 1486,
 "่าย": 1462,
 "นะค": 1461,
 "ใหม": 1461,
 "าคา": 1458,
 "บ้า": 1455,
 "เพื": 1450,
 "พื่": 1446,
 "้อม": 1434,
 "ันเ": 1430,
 "ถึง": 1427,
 "จริ": 1421,
 "พรา": 1419,
 "้อน": 1407,
 "ซื้": 1402,
 "ราะ": 1394,
 "เพร": 1394,
 "หรื": 1377,
 "ามา": 1366,
 "ม่ม": 1355,
 "ถ้า": 1346,
 "กระ": 1332,
 "ลัง": 1332,
 "ริง": 1325,
 "บาท": 1312,
 "ต่อ": 1312,
 "เหม": 1306,
 "รู้": 1299,
 "ยยย": 1296,
 "น่า": 1281,
 "ิ่ม": 1270,
 "ช่ว": 1270,
 "ทาง": 1260,
 "ทั้": 1258,
 "ันท": 1257,
 "ออก": 1252,
 "นมา": 1244,
 "าขา": 1242,
 "ั่ง": 1228,
 "ากก": 1225,
 "ล้า": 1221,
 "ก่อ": 1217,
 "จ้า": 1214,
 "เสี": 1204,
 "่วย": 1203,
 "ั่น": 1201,
 "ึ้น": 1199,
 "ขึ้": 1198,
 "ไทย": 1192,
 "รัก": 1189,
 "เดี": 1165,
 "อนเ": 1159,
 "ภาพ": 1154,
 "ียว": 1149,
 "น้อ": 1142,
 "ุ่น": 1141,
 "เท่": 1139,
 "หมื": 1139,
 "นั้": 1136,
 "ตอน": 1134,
 "อะไ": 1120,
 "เมื": 1111,
 "บอก": 1108,
 "ก้อ": 1108,
 "บริ": 1106,
 "ผู้": 1102,
 "ราย": 1096,
 "รีย": 1092,
 "ไหน": 1091,
 "ด้า": 1088,
 "ี่ไ": 1083,
 "สีย": 1081,
 "งไม": 1078,
 "่วน": 1075,
 "ติด": 1069,
 "เหล": 1067,
 "เกิ": 1066,
 "งที": 1064,
 "เรื": 1060,
 "ิ่ง": 1057,
 "เลื": 1056,
 "้าเ": 1047,
 "ือก": 1036,
 "าจะ": 1036,
 "ะไร": 1033,
 "สาข": 1029,
 "าที": 1023,
 "้อย": 1016,
 "บัต": 1013,
 "่าเ": 1013,
 "ี้ย": 1012,
 "ขาย": 1012,
 "ปิด": 1008,
 "นไป": 1008,
 "ื่น": 1007,
 "ลูก": 1005,
 "จัด": 997,
 "ระเ": 992,
 "จะเ": 986,
 "ค่า": 986,
 "นัก": 985,
 "รุ่": 976,
 "ัตร": 973,
 "เคร": 973,
 "มาร": 972,
 "ี่ส": 968,
 "หมด": 964,
 "้าย": 962,
 "องก": 959,
 "ด้เ": 958,
 "ับเ": 957,
 "ตั้": 955,
 "เห็": 954,
 "ียง": 954,
 "างเ": 953,
 "ส่ว": 947,
 "พร้": 947,
 "แม่": 945,
 "หน่": 942,
 "พี่": 938,
 "้าม": 938,
 "แค่": 935,
 "เวล": 935,
 "าร์": 935,
 "ผิว": 929,
 "งกา": 925,
 "ไปก": 922,
 "ชอบ": 922,
 "ังไ": 918,
 "กกก": 917,
 "วลา": 916,
 "กลั": 915,
 "ตาม": 914,
 "ดีย": 911,
 "ห็น": 904,
 "นไม": 900,
 "เอง": 897,
 "ก็ไ": 890,
 "โปร": 881,
 "ลอง": 880,
 "หลั": 878,
  "งมา": 871,
 "าไม": 868,
 "ลาย": 864,
 "นกั": 863,
 "เพิ": 862,
 "อนน": 862,
 "พิ่": 857,
 "าไป": 854,
 "ไหม": 851,
 "ามั": 850,
 "ะคะ": 849,
 "ขับ": 848,
 "ึ่ง": 842,
 "ละเ": 842,
 "ววว": 842,
 "ลับ": 840,
 "่าไ": 836,
 "าาา": 834,
 "ไปเ": 832,
  "เจ้": 831,
 "สาม": 830,
 "มาเ": 823,
 "้าไ": 822,
 "ล่า": 822,
 "ันไ": 821,
    "้าอ": 816,
 "ันแ": 814,
 "มื่": 812,
 "จะไ": 809,
 "กมา": 808,
 "สัน": 806,
 "สวย": 805,
 "ครื": 804,
 "ห้เ": 796,
  "คิด": 795,
  "ารเ": 792,
 "เคย": 792,
 "ีวิ": 791,
 "เร็": 790,
 "รอบ": 787,
 "ิกา": 787,
 "รรม": 785,
 "รี่": 785,
 "ินเ": 784,
 "ใคร": 783,
 "่วม": 782,
 "เปิ": 778,
 "านเ": 777,
 "เจอ": 777,
 "งนี": 777,
 "ะคร": 776,
 "ร่ว": 775,
  "ารถ": 773,
 "นเล": 772,
 "ายเ": 772,
 "ุ่ม": 772,
 "ากา": 766,
 "นกา": 766,
 "ลอด": 765,
 "ียน": 764,
 "ใช่": 763,
 "หรอ": 763,
 "เปล": 761,
 "ี่ม": 760,
 "่าจ": 755,
 "นได": 752,
 "ชั่": 752,
 "ักษ": 751,
 "่าว": 751,
 "ยอะ": 747,
 "นเด": 746,
 "้เล": 736,
 "มั้": 735,
 "ๆๆๆ": 734,
 "กษา": 732,
 "ชื่": 731,
 "บาง": 725,
 "ร์ช": 725,
 "นแล": 724,
 "ทำไ": 724,
 "หาร": 722,
 "มาส": 717,
 "ลยค": 713,
 "นนน": 713,
 "นิส": 710,
 "ี้เ": 707,
 "นคร": 705,
 "หัว": 705,
 "ียด": 703,
 "งกั": 702,
 "หมา": 699,
 "มัย": 697,
 "าติ": 695,
 "เดิ": 693,
 "องค": 693,
 "ด้ท": 692,
 "็นเ": 689,
 "ลี่": 689,
 "นใจ": 686,
 "นด้": 686,
 "เรี": 683,
 "นาม": 681,
 "่วง": 679,
 "ยค่": 678,
 "น่อ": 677,
 "้งแ": 675,
 "ระบ": 675,
 "ถูก": 674,
 "เงิ": 672,
  "โดย": 666,
 "ายก": 663,
 "งิน": 662,
 "อนา": 658,
 "รั้": 658,
 "ดือ": 656,
 "นทร": 655,
 "องไ": 655,
 "เดื": 654,
  "องแ": 648,
 "้ที": 648,
 "งให": 647,
 "ั้ย": 647,
 "ัวเ": 645,
 "ถาม": 644,
 "โรง": 644,
 "หลา": 644,
 "างก": 643,
 "คับ": 643,
 "ี่ร": 642,
 "นก็": 642,
 "พยา": 640,
 "ามเ": 640,
  "เต็": 639,
 "เยอ": 638,
 "ูกค": 638,
 "นเก": 638,
 "เนื": 635,
 "่ไม": 632,
 "มาย": 631,
  "กค้": 631,
 "อัน": 630,
 "นต์": 630,
 "เค้": 629,
 "กิด": 628,
 "ะเร": 624,
 "ะเท": 624,
 "ำไม": 622,
 "องม": 621,
 "เขา": 618,
 "าเป": 616,
 "เทศ": 614,
 "รุง": 613,
 "์ช้": 609,
 "ฟ้า": 608,
 "แพง": 608,
 "งแต": 607,
 "นให": 607,
 "่งเ": 607,
 "ิดต": 607,
 "ชาต": 603,
 "องท": 603,
 "ขวด": 603,
 "ส่ง": 599,
 "ม่ใ": 598,
 "าหา": 597,
 "แสง": 597,
 "ก็เ": 595,
 "ลาด": 595,
 "กล้": 595,
 "ริก": 594,
 "นขอ": 593,
 "บาล": 592,
 "แน่": 591,
 "่ใช": 590,
 "สั่": 590,
 "ือง": 589,
 "ียบ": 588,
 "หรี": 587,
 "สุข": 584,
 "บบน": 584,
 "ะมา": 583,
 "มีค": 580,
 "้าว": 580,
 "อนก": 579,
 "กกิ": 578,
 "งไป": 577,
 "นอน": 577,
 "ุหร": 577,
 "้าท": 577,
 "ากเ": 576,
 "กที": 576,
 "หรั": 576,
 "ผ้า": 576,
 "าบา": 575,
 "ิสส": 575,
 "ยคร": 574,
 "อ่ะ": 573,
 "ข้อ": 573,
 "นั่": 573,
  "ากไ": 572,
 "หาย": 572,
 "บุห": 571,
  "ร่า": 570,
 "มกั": 570,
 "บนี": 569,
 "ม่อ": 569,
 "งวั": 568,
 "อบค": 568,
 "ปกิ": 568,
 "ี่แ": 567,
 "ิงๆ": 567,
 "ำให": 567,
 "ับส": 567,
 "องร": 567,
 "ือเ": 565,
 "สสั": 565,
 "าแล": 564,
  "ใหญ": 561,
  "หญ่": 560,
 "ำหร": 560,
 "แรก": 560,
 "งเล": 558,
 "สิง": 557,
 "ติม": 556,
 "ฟรี": 556,
 "สาร": 556,
 "ี่จ": 554,
 "เที": 552,
 "ม่ร": 551,
 "สำห": 550,
 "ยนะ": 549,
 "มึง": 548,
 "ลิก": 547,
 "ิงห": 546,
 "อออ": 545,
 "ะเอ": 545,
 "ต้น": 545,
 "ะเป": 544,
 "อนด": 544,
 "ายไ": 543,
 "นาน": 543,
 "ท้า": 542,
 "ายใ": 542,
 "้าใ": 540,
 "ี่น": 538,
 "มีเ": 537,
 "งเป": 537,
 "คัน": 535,
 "่อไ": 534,
 "แรง": 533,
 "นเป": 530,
 "เติ": 530,
 "่เค": 530,
 "คืน": 529,
 "เลิ": 529,
 "แดด": 529,
 "จะม": 529,
 "ต็ม": 528,
 "องส": 527,
 "รอง": 526,
 "ี่ห": 525,
 "ไว้": 525,
  "ห้อ": 523,
 "แดก": 521,
 "่ยน": 519,
 "อาห": 519,
 "พวก": 519,
 "้นเ": 519,
 "เกี": 518,
  "ต่า": 517,
 "แก้": 515,
  "ดิน": 513,
 "ันก": 513,
 "นื้": 513,
 "ร่อ": 512,
 "ใส่": 512,
 "ี่ค": 512,
 "ทำใ": 512,
 "ร์ต": 511,
 "สอบ": 511,
 "ชั้": 511,
 "อร่": 510,
 "าให": 510,
 "างค": 509,
 "งหน": 509,
 "่เห": 509,
 "ยาบ": 508,
  "่าก": 506,
 "รวจ": 506,
 "่เป": 504,
 "ปลี": 504,
 "ับค": 503,
 "ินไ": 503,
 "านั": 502,
 "็ไม": 501,
 "กได": 501,
 "าเล": 501,
 "านี": 501,
 "นหน": 500,
 "ดเล": 499,
 "เลี": 499,
 "่มเ": 499,
 "งห์": 499,
 "กเล": 496,
 "เด็": 496,
 "องใ": 493,
 "ไฟฟ": 492,
 "ดีก": 490,
 "งงง": 490,
 "ีโอ": 490,
 "ฟฟ้": 489,
 "โรค": 488,
 "นอย": 488,
 "ังเ": 487,
 "าอน": 487,
 "อนไ": 486,
  "มาแ": 485,
 "หลื": 485,
  "ามส": 484,
 "ันส": 484,
  "เชี": 483,
 "ม่ต": 483,
 "โดน": 483,
 "่จะ": 482,
 "นเร": 482,
 "นจะ": 482,
 "ต่เ": 481,
 "ราช": 480,
 "ผ่า": 480,
 "สนุ": 479,
 "อื่": 479,
 "งเท": 478,
 "กงา": 478,
 "วิต": 477,
 "ต้า": 475,
 "เอ็": 475,
 "ม่ก": 474,
 "ะมี": 473,
 "ตรง": 472,
 "ับก": 470,
 "ระช": 469,
 "ดื่": 468,
 "องด": 468,
 "หนั": 468,
 "ล่อ": 467,
 "านม": 467,
 "มะเ": 467,
 "ม่ค": 467,
 "พระ": 466,
 "่ยว": 466,
 "งมี": 465,
 "อกเ": 465,
 "บมา": 465,
 "อาก": 465,
 "ื่ม": 463,
 "ระก": 462,
 "เล่": 461,
 "่ต้": 461,
 "ินท": 461,
 "นาด": 459,
 "ลิต": 459,
 "ร็ง": 458,
 "ปัญ": 458,
 "บาย": 458,
 "่นเ": 456,
 "นวั": 456,
 "กติ": 455,
 "าสด": 454,
   "งเร": 452,
 "ีที": 451,
 "ในก": 450,
 "อนแ": 449,
 "่อม": 448,
 "นเส": 448,
 "้าก": 448,
 "ป้ง": 447,
 "้าแ": 447,
 "ทธิ": 447,
 "ื้น": 446,
 "ังค": 446,
 "่มา": 446,
 "้วน": 445,
 "ราบ": 444,
 "ผิด": 444,
 "ะได": 444,
 "ขนา": 443,
 "ะไม": 443,
  "กรร": 442,
 "ารแ": 441,
 "เนี": 441,
 "แป้": 441,
 "ันม": 440,
 "่าส": 439,
 "ชีว": 439,
 "ารท": 438,
 "ยกา": 438,
 "ับร": 438,
  "ง่า": 438,
 "บาบ": 437,
 "งได": 437,
 "นดี": 436,
 "ตอร": 436,
 "ัวใ": 436,
 "ชุด": 435,
 "หมู": 435,
 "ยมา": 435,
 "มเค": 435,
 "องน": 434,
 "าใช": 433,
 "มอง": 432,
 "งคร": 432,
 "คอน": 432,
 "นเห": 431,
 "นเอ": 431,
 "านไ": 431,
 "เตอ": 430,
 "สิน": 430,
 "กรุ": 430,
 "ดับ": 430,
 "ิดเ": 429,
 "นตั": 429,
 "ชีย": 429,
 "ายแ": 428,
 "ด้ร": 428,
 "ด้อ": 428,
 "ารั": 428,
 "าก็": 427,
 "ทาน": 427,
 "านท": 426,
 "้มา": 426,
 "นนะ": 426,
 "วยก": 425,
 "ยใน": 425,
 "ั่ว": 423,
 "ามี": 423,
 "ิ้น": 423,
 "ายน": 423,
 "ันค": 423,
 "่สุ": 422,
 "ับม": 422,
 "าได": 422,
 "นเพ": 420,
 "นน้": 419,
 "โทร": 419,
 "กรา": 418,
 "านก": 418,
 "เพล": 418,
 "้อเ": 416,
 "างไ": 416,
 "วยเ": 416,
 "สด้": 415,
 "ี่ก": 415,
 "เพี": 414,
 "ือด": 412,
 "เซ็": 412,
  "หล้": 412,
 "ี่อ": 411,
 "หมอ": 411,
 "ำลั": 410,
 "สิท": 410,
 "ัญห": 410,
 "ควร": 410,
 "ายล": 410,
 "ีกว": 410,
 "ครี": 409,
 "ิทธ": 409,
 "็นท": 408,
 "ินค": 408,
 "รีม": 408,
 "่นอ": 408,
 "ยนต": 408,
 "กำล": 408,
 "าไห": 408,
 "ญหา": 407,
 "ด้แ": 407,
 "ม่ง": 407,
 "บีก": 406,
 "่ไห": 406,
 "มาใ": 405,
 "จัง": 405,
 "งใน": 404,
 "น่น": 404,
 "นละ": 404,
 "ลี้": 404,
 "้ยง": 404,
 "รณ์": 404,
 "นไห": 403,
 "ากร": 403,
 "ากั": 403,
 "ักง": 403,
 "องพ": 403,
 "ตลอ": 403,
 "ามร": 402,
 "งจะ": 402,
 "มีส": 401,
 "่าม": 400,
 "้แล": 400,
 "ี้ไ": 400,
 "์ที": 400,
 "พีย": 398,
 "งแล": 398,
 "ากิ": 398,
 "อ่า": 397,
 "ันอ": 397,
 "ังก": 397,
 "อให": 397,
 "ทัน": 396,
 "รวม": 395,
 "นใน": 395,
  "กิจ": 395,
 "รงพ": 395,
 "ตอบ": 395,
 "ันต": 394,
 "ในร": 394,
 "ู้ส": 394,
 "้วเ": 393,
 "้าส": 393,
 "ในเ": 393,
 "ภัย": 392,
 "กไป": 392,
 "ระจ": 391,
 "อาย": 390,
 "ลีโ": 390,
 "หร่": 390,
 "ัดเ": 390,
 "นาว": 389,
 "เย็": 389,
 "เอี": 389,
 "วเอ": 389,
 "ตรว": 388,
 "เศษ": 388,
 "มีแ": 388,
 "โสม": 388,
 "บกา": 387,
 "เริ": 387,
 "้งเ": 386,
 "ขอบ": 386,
 "้าห": 386,
 "ตรี": 385,
 "งโส": 385,
 "มีอ": 385,
 "อีย": 385,
 "ับป": 384,
 "สูง": 383,
 "กแล": 383,
 "สงโ": 383,
 "งปร": 383,
 "องข": 382,
 "่อเ": 382,
 "ระด": 381,
 "งพย": 381,
 "องห": 381,
 "มที": 381,
 "ับผ": 381,
 "ปล่": 381,
 "บกั": 381,
 "วกั": 380,
 "อาจ": 380,
 "บคุ": 380,
 "็นค": 379,
 "ุกค": 379,
 "ี่ต": 379,
 "างน": 379,
 "ปรั": 379,
  "ละค": 379,
 "รูป": 378,
 "ับไ": 378,
 "ย็น": 378,
 "ริ่": 377,
 "ยละ": 377,
 "งก็": 377,
 "งขอ": 377,
 "านแ": 376,
 "นแด": 375,
 "ระห": 375,
 "อกม": 375,
 "ันด": 375,
 "ยที": 374,
 "นุก": 374,
 "ะชา": 374,
 "าอย": 373,
 "าขอ": 373,
 "คนเ": 373,
 "นทา": 371,
 "ล่น": 371,
 "ินแ": 371,
 "นต้": 370,
 "ข่า": 369,
 "องอ": 369,
 "ยไม": 369,
 "่นใ": 369,
 "ปกต": 368,
 "ะกั": 368,
 "นมั": 368,
 "กี่": 368,
 "ียม": 368,
 "ินน": 368,
 "ทอง": 367,
 "ทรั": 367,
 "องโ": 367,
 "ฮอน": 367,
 "ยกั": 366,
 "ราม": 365,
 "มรา": 365,
 "ยต้": 365,
 "ระท": 364,
 "งเด": 364,
 "กตั": 364,
 "งค์": 364,
 "างว": 364,
 "นปร": 364,
 "่ดี": 363,
 "ซึ่": 362,
  "ด้ไ": 362,
 "ะบบ": 362,
  "ม่แ": 362,
 "ี่ป": 361,
 "้รั": 361,
 "กคร": 361,
 "้นไ": 361,
 "ดัง": 360,
 "มีก": 360,
 "จ่า": 360,
 "ดีเ": 359,
 "ไหร": 359,
 "ห้ค": 358,
 "ี่ท": 358,
 "่าค": 358,
 "ยวก": 358,
 "วาน": 357,
 "นคน": 357,
 "าบี": 357,
 "นค่": 357,
 "มเต": 357,
 "ิเศ": 357,
  "ีก้": 355,
 "ห้า": 355,
 "้วก": 355,
 "ากๆ": 355,
 "กกว": 354,
  "ดตั": 353,
 "พิเ": 353,
 "มูล": 353,
 "พลา": 353,
 "้าร": 353,
 "วยค": 353,
 "งกร": 352,
 "ันห": 352,
 "กให": 352,
 "องต": 352,
 "ยิ่": 352,
 "ล่ะ": 352,
 "ารา": 352,
 "่รู": 351,
 "นมี": 351,
 "งตั": 350,
 "ากม": 350,
 "้ไม": 350,
 "้นท": 349,
 "บปร": 349,
 "หมค": 349,
  "สนใ": 348,
 "กาย": 348,
 "านน": 348,
 "อกว": 348,
 "้วค": 348,
 "ครอ": 348,
 "ธรร": 346,
 "กีย": 346,
  "จ้ง": 345,
 "่าร": 345,
 "ี้ก": 344,
 "สบา": 344,
 "วที": 344,
 "ี้ค": 344,
 "เหน": 343,
 "หล่": 342,
 "้าข": 342,
 "ไปด": 342,
 "้าค": 342,
 "นด์": 341,
 "ก็ต": 341,
 "ะเล": 340,
 "นอะ": 340,
 "กซี": 340,
 "ียก": 340,
 "่นี": 340,
 "รรค": 339,
 "กาศ": 339,
 "รถเ": 339,
 "ับแ": 339,
 "ค่อ": 339,
 "สมั": 339,
 "าร่": 338,
 "สัก": 338,
 "มีป": 338,
 "โลก": 338,
 "มิน": 338,
 "นเน": 338,
 "าคม": 338,
 "ม่ส": 337,
 "กลา": 337,
 "คนท": 337,
 "แจ้": 336,
 "งอย": 336,
 "งเพ": 336,
 "าเห": 336,
 "ร์เ": 335,
 "่เก": 335,
 "เก็": 335,
 "นอก": 335,
    "อไม": 334,
 "ห้ก": 334,
 "ี้แ": 333,
 "องจ": 333,
 "ารณ": 333,
 "ม่ท": 333,
 "แดง": 333,
 "ทรา": 333,
 "มชั": 333,
 "ขภา": 333,
 "ันจ": 332,
 "ุขภ": 332,
 "นบา": 332,
  "อ็ม": 332,
 "้ได": 332,
 "ลิป": 332,
 "มั่": 331,
 "แหล": 331,
 "เหต": 331,
 "งใช": 331,
 "รีเ": 330,
 "หตุ": 330,
 "ด้ม": 329,
 "ดดด": 328,
 "้บร": 328,
 "ยอด": 328,
 "ินก": 327,
 "บุร": 327,
 "จับ": 327,
 "ม่ห": 327,
 "พนั": 327,
 "ร์ส": 327,
 "านต": 327,
 "กคน": 327,
 "สอง": 326,
 "่ที": 326,
 "วหน": 326,
 "เสร": 325,
 "างแ": 325,
 "่าท": 325,
 "ทย์": 325,
 "่ค่": 325,
 "ายค": 325,
 "ุรี": 324,
 "ยได": 324,
 "ี้ม": 324,
 "รัฐ": 324,
 "สึก": 324,
 "ไปท": 323,
 "แพ้": 322,
 "ผลิ": 322,
 "อไป": 322,
 "เทพ": 321,
 "้าบ": 321,
 "าเร": 321,
 "ปรโ": 320,
 "ด็ก": 320,
 "คู่": 320,
 "รโม": 320,
 "ไปแ": 319,
 "ยไป": 319,
 "้กั": 319,
 "เช่": 318,
 "อมา": 318,
 "าเด": 318,
 "สาย": 317,
 "นอา": 317,
 "แถม": 317,
 "้สึ": 317,
 "มมม": 316,
 "ับท": 316,
 "ับบ": 315,
 "พูด": 315,
 "มเป": 315,
 "็มเ": 315,
 "ินอ": 315,
 "งไง": 314,
 "ร์ด": 314,
 "งแร": 314,
 "ลื่": 313,
 "งเห": 313,
 "พัน": 313,
 "ไปห": 313,
 "ดให": 313,
 "่งน": 313,
 "อกต": 313,
 "อมเ": 312,
 "้ไป": 312,
 "หวั": 312,
 "ากค": 312,
 "่แล": 312,
 "ดิม": 312,
 "กวั": 312,
 "มาท": 312,
 "ราก": 311,
 "ไปไ": 311,
 "จอง": 311,
 "ำหน": 311,
 "ระส": 311,
 "างท": 311,
 "่าแ": 311,
 "นเต": 311,
 "ปลอ": 310,
 "ี่ใ": 310,
  "้เป": 310,
  "ะนำ": 310,
 "ักเ": 310,
 "ิ่น": 309,
 "อกไ": 309,
 "ิร์": 309,
 "เนอ": 309,
 "ุงเ": 308,
 "่ก็": 308,
 "ยให": 308,
 "ุ่ง": 307,
 "ม่น": 307,
 "คนไ": 307,
 "รที": 307,
 "ลัก": 306,
 "่งก": 306,
 "ฟอร": 306,
 "ยแล": 305,
 "นนั": 305,
  "แอด": 305,
 "งเก": 305,
 "่งข": 304,
 "ร์ท": 304,
 "ุ้น": 304,
 "็ได": 304,
 "นแร": 304,
 "ดมา": 304,
 "งจา": 304,
 "ตี้": 303,
 "พรร": 303,
 "อเป": 303,
 "นะน": 302,
 "ินส": 302,
 "นเบ": 301,
 "ี่บ": 301,
 "ดแล": 301,
 "นแบ": 301,
 "ับข": 301,
 "ดูแ": 301,
 "ายท": 300,
 "ด้น": 300,
 "ภาย": 300,
 "วยน": 300,
 "พาะ": 300,
 "าวา": 300,
 "ซ็น": 300,
 "็นต": 300,
 "าตั": 299,
 "งรา": 299,
  "่ไฟ": 298,
 "วนี": 298,
 "้มี": 298,
 "สิร": 298,
 "พ่อ": 297,
 "ราเ": 297,
 "กัด": 297,
  "ีมา": 297,
  "านา": 296,
 "ปเล": 296,
 "็นแ": 296,
 "อิน": 296,
 "โมช": 296,
 "อกา": 296,
 "านอ": 296,
 "นึง": 295,
 "โคร": 295,
 "้ว่": 295,
 "่ทำ": 295,
 "กอย": 294,
 "ังส": 294,
 "อดี": 294,
 "เสื": 294,
  "ิ้ง": 293,
 "หนึ": 293,
 "งดี": 293,
 "มไม": 293,
 "นหล": 293,
 "อกั": 292,
 "ุกร": 292,
 "กไม": 291,
 "ทำง": 291,
 "มาต": 291,
 "นีย": 291,
  "นตร": 290,
 "ากล": 290,
 "ายุ": 290,
 "ารส": 290,
 "้ค่": 290,
 "ลิ่": 290,
 "่าต": 290,
 "ะไป": 290,
 "ำงา": 289,
 "็นส": 289,
 "ต่ก": 289,
 "วาร": 289,
 "ธิ์": 289,
 "ละก": 289,
 "นิด": 289,
 "ดไป": 288,
 "แนะ": 288,
   "ต่ง": 288,
 "้ำม": 287,
 "หละ": 287,
  "สาว": 287,
 "หาก": 286,
 "ล็ก": 286,
 "นย์": 286,
 "อ่อ": 286,
 "ากใ": 286,
 "่เร": 286,
 "็นอ": 285,
 "นเท": 285,
 "กลิ": 285,
 "โตโ": 285,
 "ตโย": 284,
 "พลง": 284,
 "ป่า": 284,
 "ศูน": 284,
 "นอี": 283,
 "ด้ค": 283,
 "โยต": 283,
 "ูนย": 283,
 "่เล": 283,
 "นสิ": 283,
 "ีให": 283,
 "ร็ว": 282,
 "็นก": 282,
 "างอ": 282,
 "ารต": 281,
 "ตลา": 281,
 "อนอ": 281,
 "่ออ": 281,
 "ครา": 280,
 "ยเห": 280,
 "ก็บ": 280,
 "นาง": 280,
 "ะที": 280,
  "ุ้ม": 279,
 "บคร": 279,
 "์สิ": 279,
 "วใจ": 279,
 "นเข": 278,
 "ูแล": 278,
 "นโล": 278,
 "่ว่": 278,
 "นไท": 278,
 "งว่": 278,
 "่งไ": 278,
 "นึ่": 278,
 "ครบ": 277,
  "นทุ": 277,
 "เมา": 277,
 "ดว่": 276,
 "แพท": 276,
 "ยี่": 276,
 "ต๊ะ": 276,
 "รอย": 275,
 "้มั": 275,
 "่ใน": 275,
 "วัล": 275,
 "โอเ": 275,
 "พลั": 274,
 "นรั": 274,
 "ังม": 274,
 "้าจ": 273,
 "นค้": 273,
 "มมั": 273,
 "ช่น": 273,
 "นส์": 272,
 "้นะ": 272,
 "อรี": 272,
 "ลัว": 272,
 "่าใ": 272,
 "เล็": 272,
 "โต๊": 271,
 "ราง": 271,
 "ือไ": 271,
 "้เร": 271,
 "ารอ": 271,
 "งกล": 270,
 "พื้": 270,
  "กกั": 269,
 "พทย": 269,
 "คุ้": 269,
 "ืออ": 269,
 "าทำ": 269,
 "ทีย": 268,
   "ังห": 268,
  "้ดี": 267,
 "่อก": 267,
 "อ้ว": 267,
 "กล่": 267,
 "งคว": 267,
 "งใจ": 266,
 "ะกา": 266,
 "่มั": 266,
 "าหน": 266,
 "เบอ": 266,
 "่าอ": 266,
 "รีบ": 266,
 "ด้ก": 265,
  "ุดท": 265,
 "ิจก": 265,
 "้วว": 265,
  "่สา": 264,
 "้ออ": 264,
 "แทน": 264,
 "านค": 264,
 "ขาว": 264,
 "นรถ": 264,
 "ลาง": 263,
 "รเล": 263,
 "ละส": 263,
 "ดที": 263,
 "ารร": 263,
 "้าต": 263,
 "างม": 263,
 "่ยง": 263,
 "คาร": 263,
 "่งท": 263,
 "งสา": 262,
 "่อร": 262,
 "ร์น": 262,
 "ป้า": 262,
 "แก่": 261,
 "าเพ": 261,
 "าใจ": 261,
 "อบถ": 261,
  "มาช": 260,
 "าคร": 260,
 "ีคว": 260,
 "ห้ท": 259,
 "ตัด": 259,
 "คลิ": 259,
 "ี่ด": 259,
 "นาค": 259,
 "ขาด": 259,
  "ต่ไ": 259,
 "องล": 259,
 "มมา": 258,
 "สมอ": 258,
 "าะเ": 258,
 "ิ้ว": 258,
 "่นน": 258,
 "อกจ": 258,
 "ตาย": 257,
 "ป้อ": 257,
 "นหม": 257,
 "มีร": 257,
  "่งใ": 257,
 "ก็ม": 257,
 "องป": 257,
 "ฉพา": 257,
 "เบา": 257,
 "เฉพ": 257,
 "จกร": 256,
 "นเม": 256,
 "ุกเ": 256,
 "สู้": 256,
 "นยา": 256,
 "ายๆ": 256,
 "งคน": 256,
 "ดีแ": 255,
 "ี่โ": 255,
 "ม่ด": 255,
 "เหี": 253,
 "ก็จ": 253,
 "รัล": 253,
 "มิต": 253,
 "รถย": 253,
 "อบเ": 252,
 "ทร์": 252,
 "งน้": 252,
 "ำมั": 252,
 "อกแ": 252,
 "ลตั": 251,
 "ุกว": 251,
 "่คร": 251,
 "งมั": 251,
 "บบเ": 251,
 "ันใ": 251,
 "ลอร": 251,
 "เก่": 251,
 "่กิ": 251,
 "ากแ": 250,
 "เชื": 250,
 "บถา": 250,
 "อยเ": 249,
 "นเค": 249,
 "ะดั": 249,
 "ากท": 249,
 "ึงเ": 249,
  "อดเ": 248,
 "มาด": 248,
 "๋ยว": 248,
 "มาน": 248,
 "นยั": 248,
 "างห": 248,
  "มได": 248,
 "องผ": 247,
  "ี๋ย": 247,
 "ปอร": 247,
 "ตัง": 247,
 "หยุ": 247,
 "ยุด": 246,
 "หิว": 246,
 "็กซ": 246,
 "ท้อ": 246,
 "องย": 246,
 "ทั่": 246,
 "ายร": 246,
 "่รั": 245,
 "งหม": 245,
 "ัดก": 245,
 "ังจ": 245,
 "วก็": 245,
  "ระต": 245,
 "่เอ": 245,
 "่นก": 245,
 "ราไ": 245,
 "ยกว": 244,
 "มว่": 244,
 "บไม": 244,
 "ลืม": 244,
 "เดอ": 243,
 "ทีม": 243,
 "ำกั": 243,
 "จัน": 242,
 "ดท้": 242,
 "เทค": 242,
 "มคร": 242,
 "ิ๊ก": 242,
 "าวเ": 242,
 "ภาษ": 242,
 "นว่": 242,
 "รอก": 241,
 "ารข": 241,
 "บอร": 241,
 "คาเ": 241,
 "นคว": 241,
 "ี่ช": 241,
 "่ให": 240,
 "ัฒน": 240,
 "นรา": 240,
 "ยาว": 240,
 "หลอ": 240,
 "หี้": 240,
 "งสิ": 240,
 "โชว": 240,
 "อนท": 240,
 "ามค": 240,
 "ระม": 240,
 "่อว": 240,
 "มีน": 239,
   "ยอย": 239,
 "ยเล": 239,
 "งเอ": 238,
 "นลด": 238,
 "เซล": 238,
  "รสช": 238,
 "อนค": 238,
 "ยเป": 238,
  "ดาว": 237,
 "สูบ": 237,
 "ีกา": 237,
 "ามม": 236,
 "นุ่": 236,
 "กสา": 236,
 "้คร": 235,
 "อนม": 235,
  "ินม": 235,
 "เต้": 235,
 "สชา": 234,
 "็นม": 234,
 "สมา": 234,
 "วไป": 234,
 "ล้อ": 234,
 "นอร": 233,
 "างส": 233,
 "บไป": 233,
 "งเส": 233,
 "ชว์": 233,
 "าจา": 233,
 "วไม": 233,
  "เตร": 233,
 "่งแ": 232,
 "ะเบ": 232,
 "วัด": 232,
  "้งน": 232,
 "กรอ": 232,
 "ายอ": 232,
 "มาจ": 232,
 "สร้": 232,
 "าดน": 232,
 "ปาก": 232,
  "าเข": 231,
 "ิตร": 231,
 "ไปอ": 231,
 "าวน": 231,
 "ิ้ม": 231,
 "ะสา": 230,
 "เขี": 230,
 "าทิ": 230,
 "็นร": 230,
 "ิดว": 229,
 "ริษ": 229,
 "ระย": 229,
 "ิษั": 229,
 "ษัท": 229,
 "้าา": 229,
  "์นี": 228,
 "ดี๋": 228,
 "หอม": 228,
 "ู้เ": 228,
  "ขีย": 228,
 "่าล": 228,
 "นจั": 228,
 "่ชอ": 227,
 "ุกส": 227,
  "ม่ช": 227,
 "อที": 227,
 "ข่ง": 227,
 "ผสม": 227,
 "นงา": 226,
 "าหล": 226,
 "ารก": 226,
 "อาท": 226,
 "่เข": 226,
 "งนะ": 226,
 "ิวเ": 226,
 "พบก": 225,
 "ก้ว": 225,
 "ราน": 225,
 "ในว": 225,
 "่นไ": 225,
 "งกว": 225,
 "นต่": 225,
 "าค่": 224,
 "นเจ": 224,
 "้ยค": 224,
  "จึง": 224,
 "นเย": 224,
 "ือบ": 224,
 "้เห": 223,
  "บรถ": 223,
 "สูต": 223,
 "ารใ": 223,
 "วมา": 223,
 "ซี่": 223,
 "นสั": 223,
 "ก็ค": 223,
 "ตรา": 222,
 "กจา": 222,
  "นกล": 222,
 "ฟัง": 222,
 "วัย": 222,
 "งกิ": 222,
  "้งห": 222,
 "งค่": 222,
 "อาร": 222,
  "ากจ": 222,
 "ูตร": 222,
 "งงา": 222,
 "าหม": 222,
  "มีใ": 221,
 "ดีม": 221,
 "แข่": 221,
 "ดนี": 221,
  "าเท": 221,
 "วให": 221,
 "ตัส": 221,
 "านะ": 221,
 "ดกา": 220,
 "แสน": 220,
 "นทั": 220,
 "ติก": 220,
 "ับพ": 220,
 "ม่ว": 220,
 "้ก็": 220,
 "ทะเ": 220,
 "ัติ": 220,
 "ยอม": 220,
 "รมา": 220,
 "งสุ": 220,
 "มีโ": 220,
 "อวั": 220,
 "างา": 219,
 "ารค": 219,
 "ริม": 219,
 "านห": 219,
 "โลต": 219,
 "ห้ม": 219,
 "นสา": 219,
 "ันว": 219,
 "าธิ": 219,
 "มหา": 219,
 "ช้เ": 219,
 "อัล": 219,
 "นัง": 219,
 "่นแ": 218,
 "ู่แ": 218,
 "ดีค": 218,
 "ะทำ": 218,
 "สิ่": 218,
 "รงก": 218,
 "กเร": 218,
 "หญิ": 217,
 "่ไป": 217,
 "ญิง": 217,
 "้งค": 217,
 "ป่ว": 217,
 "้จั": 217,
 "ไลน": 217,
 "่อค": 217,
 "ห้ผ": 216,
 "ถือ": 216,
 "เมน": 216,
 "ชาช": 216,
 "สี่": 216,
 "ยาม": 216,
 "เสิ": 216,
  "ีเอ": 216,
 "ู้จ": 215,
 "มาล": 215,
 "้นม": 215,
 "วนล": 215,
 "ดอก": 215,
 "อาเ": 215,
 "างๆ": 215,
 "ารม": 215,
 "ยัด": 215,
 "้นก": 215,
 "ผ่อ": 214,
 "วัง": 214,
 "ถยน": 214,
 "อนห": 214,
 "ลน์": 214,
 "ระโ": 214,
 "างใ": 214,
 "อเล": 214,
 "ีเซ": 213,
 "านบ": 213,
 "ชวน": 213,
 "่ร้": 213,
 "บรร": 213,
 "จะก": 213,
  "งสั": 213,
 "ากส": 213,
 "จัก": 213,
 "เด้": 212,
 "นึก": 212,
 "กจะ": 212,
 "ยาย": 212,
 "นพร": 212,
 "ะรา": 212,
 "ลยน": 212,
 "ุดเ": 212,
 "ดตา": 212,
 "ักก": 212,
 "ช้แ": 212,
 "ังน": 211,
 "งไห": 211,
 "นแต": 211,
 "่กล": 211,
 "นับ": 211,
 "ใจเ": 211,
 "แห่": 211,
 "ดอะ": 211,
 "ดต่": 211,
 "ปวด": 210,
 "ะค่": 210,
 "ันธ": 210,
 "้จะ": 210,
 "วิว": 210,
 "ี่ข": 210,
 "ห้ไ": 210,
 "ทีเ": 210,
 "ขาเ": 210,
 "มาณ": 209,
 "มคว": 209,
  "าดู": 209,
 "โมง": 209,
  "ิดก": 209,
 "ายต": 209,
 "งต้": 209,
 "ำนว": 208,
 "าปร": 208,
 "ใกล": 208,
 "ด้ส": 208,
 "จะอ": 208,
 "ห้ส": 208,
 "นระ": 208,
 "าพร": 208,
 "ชิ้": 208,
 "่าห": 208,
 "ินบ": 208,
 "าดี": 208,
 "าชน": 208,
 "ินข": 208,
 "มาอ": 207,
 "ช้อ": 207,
 "บที": 207,
 "อดม": 207,
 "จุด": 206,
 "าชิ": 206,
 "นกว": 206,
 "ารป": 206,
 "กลุ": 206,
 "งเบ": 206,
 "ัดส": 206,
 "รีว": 205,
 "งจั": 205,
 "งนั": 205,
 "กค่": 205,
 "ดีๆ": 205,
 "าสา": 205,
 "ายด": 205,
 "ดีท": 204,
 "าเก": 204,
 "ก็ย": 204,
 "้วไ": 204,
 "่งต": 204,
 "ี่พ": 204,
 "อัพ": 204,
 "่งม": 204,
 "๋อง": 204,
 "งคื": 204,
 "ศรี": 204,
 "ถอะ": 204,
 "ี่ผ": 204,
 "ายส": 204,
 "นคื": 204,
 "มรั": 203,
 "หวา": 203,
 "อยค": 203,
 "้ยย": 203,
 "ร็จ": 203,
 "อมู": 203,
  "เมอ": 203,
 "าอี": 203,
 "้อไ": 203,
 "ะจำ": 203,
 "้นอ": 203,
  "ไปใ": 203,
 "งขั": 202,
 "ร์ค": 202,
 "้งท": 202,
 "ลุ่": 202,
 "นนิ": 202,
 "ในป": 202,
 "ดกั": 202,
 "มาไ": 202,
 "่อใ": 202,
 "เกล": 202,
  "นออ": 202,
 "าสุ": 201,
 "ติเ": 201,
 "เหร": 201,
 "ู่ใ": 201,
 "นาย": 201,
 "ดน้": 201,
 "ายข": 201,
 "ิดท": 201,
 "ไปต": 201,
 "หยั": 201,
 "วมร": 201,
 "่อส": 200,
 "ามห": 200,
 "ราว": 200,
 "งทำ": 200,
 "่ขอ": 200,
 "นนา": 200,
 "กหน": 200,
 "วาง": 200,
 "ายย": 200,
 "ละม": 200,
 "์มา": 200,
 "มีท": 199,
 "่คุ": 199,
 "ะอา": 199,
 "ยใจ": 199,
 "สัม": 199,
 "่ห้": 199,
 "ายม": 199,
 "ัวน": 199,
 "ากน": 199,
 "จะร": 199,
 "าต้": 198,
  "แท็": 198,
 "ส้น": 198,
 "สสส": 198,
 "ตย์": 198,
 "ะหย": 198,
 "ับน": 198,
 "น่ะ": 198,
 "างร": 198,
 "าะก": 198,
 "มนี": 198,
  "เถอ": 198,
  "อกก": 198,
 "าเอ": 197,
 "นข้": 197,
 "ลีย": 197,
 "จอก": 197,
 "ท็ก": 197,
 "ป๋อ": 197,
 "ห่ง": 197,
 "ลาก": 197,
 "ดหน": 197,
 "งคุ": 197,
 "รอค": 197,
 "ามอ": 197,
 "อนร": 197,
 "พรี": 197,
 "็นน": 196,
 "ารด": 196,
 "าด้": 196,
 "งต่": 196,
 "กกา": 196,
 "รให": 196,
 "สือ": 195,
 "เก้": 195,
 "ะกิ": 195,
 "บิ๊": 195,
 "ก็แ": 195,
 "งรถ": 195,
 "งหล": 195,
  "ออน": 195,
 "กแบ": 195,
 "แย่": 194,
 "ไปส": 194,
 "ในโ": 194,
 "าว่": 194,
 "จะใ": 194,
 "ารบ": 194,
 "มีข": 193,
 "มรู": 193,
 "ีนี": 193,
 "องช": 193,
 "เคล": 193,
 "บคว": 193,
 "ับต": 193,
 "ิธี": 192,
 "ราจ": 192,
 "สัส": 192,
 "นแม": 192,
 "ยคะ": 192,
 "ยดี": 192,
  "ดใน": 192,
 "้นค": 191,
 "าดเ": 191,
 "#แป": 191,
 "่งส": 191,
 "ี้อ": 191,
 "็นไ": 191,
 "ันย": 191,
 "งรั": 191,
  "ร์ม": 190,
 "ำรุ": 190,
 "วมก": 190,
 "บาร": 190,
 "มค่": 190,
 "ทิต": 190,
 "สดง": 190,
 "ัวแ": 190,
 "ดไม": 190,
 "สัง": 190,
 "ปกั": 190,
 "ก็อ": 190,
 "าเจ": 190,
 "อคร": 190,
 "ใต้": 190,
 "้นแ": 189,
 "พัก": 189,
 "องว": 189,
 "้กิ": 189,
 "ปแล": 189,
 "นกร": 189,
 "ว้า": 189,
 "ับโ": 189,
  "อนจ": 189,
 "นื่": 188,
 "๊กซ": 188,
 "ดมิ": 188,
  "งด้": 188,
  "ับอ": 188,
 "งอา": 188,
 "้ทุ": 188,
 "ีค่": 188,
 "็นพ": 187,
 "สิว": 187,
 "วค่": 187,
 "ริส": 187,
 "้งใ": 187,
 "ละร": 187,
 "ป่ะ": 187,
 "ก่า": 187,
 "โฆษ": 187,
 "ะตู": 186,
 "านใ": 186,
 "นบ้": 186,
 "่ร่": 186,
 "ยขอ": 186,
 "ละอ": 186,
 "นส่": 186,
 "วคร": 186,
 "เบื": 185,
 "อเค": 185,
 "มแล": 185,
 "ายา": 185,
 "แสด": 185,
 "ดูด": 185,
 "้วจ": 185,
 "าไร": 185,
 "ก้น": 185,
 "ด้ด": 185,
  "งแบ": 185,
 "รถไ": 184,
 "แปล": 184,
 "งหว": 184,
 "บำร": 184,
 "างจ": 184,
 "่นั": 184,
 "าตร": 184,
 "นสุ": 184,
 "ีปั": 184,
 "กเก": 184,
 "่งอ": 184,
 "างข": 184,
 "งเค": 184,
 "ตรเ": 183,
 "ณฑ์": 183,
 "ช่อ": 183,
 "มาะ": 183,
 "ุณล": 183,
 "ีอา": 183,
  "ผมเ": 183,
 "ข็ง": 183,
 "จะท": 183,
 "เส้": 183,
 "รรั": 183,
 "ังใ": 182,
 "อเร": 182,
 "ีแม": 182,
 "วเล": 182,
 "ด้ห": 182,
 "พรุ": 182,
 "จำก": 182,
 "หนื": 182,
  "งนา": 182,
  "บสน": 182,
 "้นต": 182,
  "คิว": 181,
 "มไป": 181,
 "ลกร": 181,
  "อว่": 181,
 "ิตย": 181,
 "าใน": 181,
 "อยม": 181,
 "้อแ": 181,
 "ดัน": 181,
 "าษี": 180,
 "เพจ": 180,
 "านข": 180,
 "เช็": 180,
 "ยนเ": 180,
 "่าา": 180,
 "้ใช": 180,
 "ู้ว": 180,
 "ษณา": 180,
 "ะเพ": 180,
 "ดเพ": 180,
 "่งห": 180,
 "ม่พ": 179,
  "รีโ": 179,
 "เบล": 179,
 "ถ่า": 179,
 "งเข": 179,
 "แข็": 179,
  "ีออ": 179,
 "่วั": 179,
 "จะต": 179,
 "ดได": 179,
  "ดขอ": 178,
 "พาไ": 178,
  "จะแ": 178,
 "ิดห": 178,
 "หนี": 178,
 "งออ": 178,
 "ฆษณ": 177,
 "ยว่": 177,
  "บว่": 177,
 "ดเด": 177,
 "นหร": 177,
 "ห่ว": 177,
 "็จะ": 177,
 "มีไ": 177,
 "่มช": 177,
 "ยงใ": 176,
 "เสา": 176,
 "มให": 176,
 "ไปค": 176,
  "องบ": 176,
 "่กั": 176,
 "ละไ": 176,
 "แตก": 176,
 "ละท": 176,
 "รัว": 176,
 "้ป่": 176,
 "มต้": 176,
 "งทา": 176,
 "่คว": 176,
 "หนา": 176,
 "่น่": 175,
 "รถใ": 175,
 "เซน": 175,
 "ิวห": 175,
 "็มี": 175,
 "ับใ": 175,
 "วนะ": 175,
 "านส": 175,
 "ดีไ": 174,
 "สงส": 174,
 "ากอ": 174,
 "ชื้": 174,
  "ไรค": 174,
 "ขาท": 174,
 "มสน": 174,
 "ูกก": 174,
 "ปรา": 174,
 "ชัด": 174,
 "ลาน": 174,
 "ไปน": 174,
 "บัน": 174,
 "วิ่": 173,
 "ัณฑ": 173,
 "้เก": 173,
 "นอั": 173,
 "งร้": 173,
  "ายั": 173,
 "อได": 173,
 "ปลา": 173,
 "ะวั": 173,
 "วกเ": 173,
 "ศึก": 172,
 "วิค": 172,
 "นวน": 172,
 "ามแ": 172,
  "ช่า": 172,
 "าชา": 172,
 "พัฒ": 172,
 "ซีว": 172,
 "ุดๆ": 172,
 "าสน": 172,
 "ามท": 172,
 "ี้น": 172,
 "ลงท": 172,
 "บิน": 172,
 "ันล": 171,
  "ซุป": 171,
 "สงก": 171,
 "้วม": 171,
 "ึงไ": 171,
 "อนต": 171,
 "วนเ": 171,
 "้เพ": 171,
 "ฒนา": 171,
 "รยา": 171,
 "มีบ": 171,
  "อบก": 170,
 "ถถถ": 170,
 "้ตั": 170,
 "่บ้": 170,
 "าเส": 170,
 "ัดไ": 170,
 "รไม": 170,
 "ครง": 170,
 "ฐาน": 170,
 "ิเว": 170,
 "มเร": 170,
 "ชาย": 170,
 "่งค": 170,
 "งข้": 170,
 "ายห": 170,
 "าซื": 170,
 "งทุ": 170,
  "ไรก": 169,
 "ีแต": 169,
 "คร้": 169,
 "ำคั": 169,
 "มเล": 169,
 "ยคว": 169,
  "แถว": 169,
 "ภัณ": 169,
 "นอื": 169,
 "อยก": 169,
 "นดั": 169,
 "ช้ไ": 169,
 "ะโย": 169,
   "ห้ห": 169,
 "เว่": 169,
 "ร์โ": 169,
  "ดูก": 169,
 "อนโ": 169,
 "กหล": 168,
 "ี้จ": 168,
 "งขึ": 168,
 "อมร": 168,
 "รปร": 168,
 "ไปจ": 168,
 "ไอ้": 168,
 "ลล์": 168,
 "อกร": 168,
 "เปร": 168,
 "สนอ": 168,
 "จอร": 168,
 "งขว": 168,
 "บ่อ": 168,
 "จะส": 168,
  "งาม": 167,
 "แจก": 167,
  "ยมี": 167,
  "ิอิ": 167,
 "ดเห": 167,
 "มัค": 167,
 "ดถึ": 167,
 "ิดแ": 167,
 "ศุก": 167,
 "สถา": 167,
 "ยชน": 167,
 "ือแ": 167,
 "ปุ่": 167,
 "เธอ": 166,
 "ะดี": 166,
 "ีคร": 166,
 "อดภ": 166,
 "วจะ": 166,
  "ทำเ": 166,
 "ู้ป": 166,
 "คดี": 166,
 "นวา": 166,
 "รัง": 166,
 "อิอ": 166,
  "หว่": 166,
 "าทา": 166,
 "อยๆ": 166,
 "้นน": 166,
 "กขอ": 166,
 "ไหว": 166,
 "ุกอ": 166,
 "วอร": 166,
 "่หน": 165,
  "กเบ": 165,
 "นกิ": 165,
 "เวอ": 165,
 "่งร": 165,
 "ัคร": 165,
 "ม่ถ": 165,
  "มกา": 165,
 "มขอ": 165,
 "้าด": 165,
 "บขอ": 165,
 "ึงก": 165,
 "ไปร": 165,
 "นะเ": 165,
 "ทำก": 165,
 "อาไ": 165,
 "้แต": 165,
 "บเร": 165,
 "ไฮเ": 165,
 "ี่ล": 165,
 "ร์ไ": 164,
 "าเบ": 164,
 "ยก็": 164,
 "ุกท": 164,
 "ด้ต": 164,
 "ดจา": 164,
 "คนอ": 164,
 "ทศไ": 164,
 "สะด": 164,
 "นแก": 164,
   "งจร": 164,
 "นทำ": 163,
 "ด่ว": 163,
 "แฟน": 163,
 "ัวไ": 163,
 "ลยเ": 163,
 "มาห": 163,
 "นจา": 163,
 "ะบะ": 163,
 "ใจใ": 163,
 "ร์บ": 163,
 "วแล": 163,
 "ดภั": 163,
  "ยกเ": 163,
 "นปี": 163,
 "่เพ": 163,
 "กด้": 163,
 "สปอ": 163,
 "ทุ่": 162,
 "าคน": 162,
 "ฝาก": 162,
 "เนเ": 162,
 "อิ่": 162,
 "อาม": 162,
 "ร่ง": 162,
  "คัญ": 162,
 "ไหล": 162,
 "สำค": 162,
 "มนู": 162,
 "ีโว": 162,
 "รจะ": 162,
 "าริ": 162,
 "่ทั": 162,
 "มสุ": 162,
  "มอร": 161,
 "ก็ส": 161,
 "างป": 161,
 "กเส": 161,
  "ทุน": 161,
 "เกา": 161,
 "นโร": 161,
 "งซื": 161,
 "ือส": 161,
 "ยาร": 161,
 "ิดข": 161,
 "้วแ": 161,
 "ปด้": 161,
 "มน้": 161,
 "บเพ": 161,
 "มาข": 161,
  "นใช": 160,
 "จะห": 160,
 "ณภา": 160,
 "รเป": 160,
 "ต่ค": 160,
 "อ้า": 160,
 "โยช": 160,
 "..เ": 160,
 "ไปซ": 160,
 "บแล": 160,
 "ึกษ": 160,
 "าอา": 160,
 "งพั": 160,
 "อะม": 160,
  "ุณภ": 159,
 "ี้ท": 159,
 "กใน": 159,
 "กเห": 159,
 "าแบ": 159,
 "โอก": 159,
 "์ให": 159,
 "โนโ": 159,
 "ยวเ": 158,
 "ห้ร": 158,
 "บเล": 158,
  "แบร": 158,
 "ทคโ": 158,
 "กเป": 158,
 "บหน": 158,
 "คโน": 158,
  "ะเห": 158,
 "ดนั": 158,
  "ต่ต": 158,
 "้ำห": 158,
 "งผิ": 158,
 "รนด": 158,
 "ห้บ": 157,
 "นเว": 157,
 "เกื": 157,
 "มตั": 157,
 "ีแล": 157,
 "กร์": 157,
 "ือค": 157,
 "มเพ": 157,
 "่ปุ": 157,
 "ลยี": 157,
 "่แพ": 157,
 "บทุ": 157,
 "ีนะ": 157,
 "่ะค": 157,
 "โลย": 157,
 "มีห": 157,
 "้นร": 157,
 "ารไ": 157,
 "แม้": 157,
 "่นๆ": 157,
 "ลยจ": 156,
 "์ทอ": 156,
 "วีย": 156,
 "้าพ": 156,
  "่คน": 156,
 "วยม": 156,
 "ิตภ": 156,
 "ณลู": 156,
 "ห้แ": 156,
 "ออส": 156,
 "วยแ": 156,
 "เซอ": 156,
 "นรอ": 156,
 "่าบ": 156,
 "ินด": 155,
 "จจะ": 155,
 "ไรเ": 155,
 "งเจ": 155,
 "เวี": 155,
 "ห้ด": 155,
 "มอเ": 155,
 "้วร": 155,
 "็นห": 155,
 "ปาร": 155,
 "ู่เ": 155,
 "ิดไ": 155,
 "ลุ้": 155,
 "จะด": 155,
 "กือ": 155,
 "ผมก": 155,
 "คุม": 154,
 "วนต": 154,
 "ชาว": 154,
 "ต่ม": 154,
 "นตอ": 154,
 "ตภั": 154,
 "งพื": 154,
 "ดเร": 154,
  "ากข": 154,
 "ทยา": 154,
 "่พอ": 154,
 "อบส": 154,
 "ชิก": 154,
 "มเห": 154,
 "เเล": 154,
 "แมค": 154,
  "ม่จ": 154,
 "ยืน": 154,
 "ะเด": 154,
 "วจส": 154,
 "ฟเฟ": 154,
 "ีคน": 154,
 "้งก": 154,
  "ชน์": 153,
 "่นท": 153,
 "ินห": 153,
 "่ปร": 153,
 "มก็": 153,
  "ฮเน": 153,
  "ากห": 153,
 "นตา": 153,
 "หาเ": 153,
  "เชิ": 153,
 "ขี่": 153,
  "้หม": 152,
 "เอก": 152,
 "ซอร": 152,
  "กรณ": 152,
 "ีสา": 152,
  "ญี่": 152,
  "ะทา": 152,
 "งตา": 152,
 "ามไ": 152,
 "มาค": 151,
 "้ไห": 151,
  "างด": 151,
 "เอะ": 151,
 "ันพ": 151,
  "สนา": 151,
  "ปเป": 151,
 "ขอเ": 151,
  "หนู": 151,
 "กเพ": 151,
 "้นส": 151,
 "บผม": 151,
 "ในง": 151,
 "กลี": 151,
 "โว่": 151,
 "ขอร": 151,
 "นาท": 150,
  "ึกว": 150,
 "กี้": 150,
 "ห้น": 150,
 "อุด": 150,
 "เช้": 150,
 "สริ": 150,
 "กปร": 150,
 "่าช": 150,
 "็นข": 150,
 "ตำร": 150,
 "าทุ": 150,
 "ดูเ": 150,
 "ต่ว": 150,
 "ในค": 150,
 "ด้ใ": 149,
 "มีต": 149,
 "้ทั": 149,
 "อเต": 149,
 "บรน": 149,
 "บผิ": 149,
 "ามก": 149,
 "วยใ": 149,
 "อมก": 149,
 "็ยั": 149,
 "แท้": 149,
 "นคุ": 149,
 "้ใน": 149,
 "าสู": 149,
 "าตา": 149,
 "บบไ": 149,
 "ด้จ": 149,
 "รถท": 149,
 "ิดอ": 149,
 "ขอใ": 149,
 "าสั": 149,
 "บตั": 148,
 "ดสิ": 148,
 "จำน": 148,
 "เทอ": 148,
 "สร็": 148,
 "จะพ": 148,
 "คยเ": 148,
 "ารจ": 148,
 "อรา": 148,
 "ร์แ": 148,
  "้ให": 148,
 "คล้": 148,
 "มกร": 148,
 "บุฟ": 148,
 "อะเ": 148,
 "อนส": 148,
 "ม่ข": 148,
 "ระร": 148,
 "ามพ": 148,
 "ด่า": 147,
 "รุป": 147,
 "กนี": 147,
 "ม้า": 147,
 "่หม": 147,
 "อคว": 147,
 "ใจไ": 147,
  "ะหว": 147,
 "ัวห": 147,
 "้นจ": 147,
 "ชุ่": 146,
 "้น้": 146,
 "รรย": 146,
 "เศร": 146,
 "ะเก": 146,
 "ิดค": 146,
 "ะอย": 146,
 "สรุ": 146,
 "ถนน": 146,
 "วิธ": 146,
 "มดเ": 146,
 "ีเว": 146,
  "งดู": 146,
 "โอ้": 146,
 "าคุ": 146,
 "นผู": 146,
 "รก็": 146,
 "อกล": 146,
 "อขอ": 146,
 "้ทา": 146,
 "ีเห": 146,
 "ามข": 146,
 "อนข": 146,
   "บบบ": 145,
 "สัย": 145,
 "้สิ": 145,
 "้ำเ": 145,
 "่หล": 145,
 "รทำ": 145,
 "วิท": 145,
 "นัด": 145,
 "ศไท": 145,
  "อนใ": 145,
 "งเม": 145,
 "้อบ": 145,
  "ึงจ": 145,
 "ยงเ": 145,
 "้วอ": 145,
 "ช้บ": 145,
 "ชีส": 145,
 "ถาน": 145,
 "บเค": 144,
 "ายป": 144,
 "ฎหม": 144,
 "งแค": 144,
  "ีเร": 144,
 "ิงค": 144,
 "ำรว": 144,
 "่ตั": 144,
 "งหร": 144,
 "กฎห": 144,
 "งล่": 144,
 "์ขอ": 144,
 "ยุค": 144,
 "ต้ม": 144,
 "ดละ": 144,
 "กรี": 144,
 "้งส": 144,
 "ับห": 144,
 "ียเ": 144,
 "โคต": 144,
 "้อค": 143,
 "คนน": 143,
 "นร้": 143,
 "ีปร": 143,
 "อเพ": 143,
 "งเต": 143,
 "นช่": 143,
 "นแค": 143,
 "นบอ": 143,
 "าเค": 143,
 "ซ่า": 143,
 "ันร": 143,
 "้นห": 143,
 "สติ": 143,
 "ยรั": 143,
 "าวๆ": 143,
 "ดขา": 143,
 "บรา": 142,
 "ะมั": 142,
 "คลื": 142,
 "้าป": 142,
 "นท์": 142,
 "็นป": 142,
 "ับช": 142,
 "วดล": 142,
 "ัยเ": 142,
 "ยคน": 142,
 "าบอ": 142,
 "นเช": 142,
 "ี้ห": 142,
 "กซ์": 142,
 "ม่ล": 142,
 "ปรุ": 142,
 "อยุ": 142,
 "ป็ด": 142,
 "ก้ไ": 142,
 "ุดแ": 142,
  "งแด": 142,
  "คนร": 142,
 "บได": 142,
 "งอะ": 141,
 "ญญา": 141,
 "ดอย": 141,
 "มอย": 141,
 "ริน": 141,
 "อบร": 141,
 "มชื": 141,
 "โชค": 141,
  "อบแ": 141,
 "ินช": 141,
 "ละแ": 141,
 "งดื": 141,
 "่นม": 141,
 "ยแบ": 141,
 "ออย": 140,
  "ี่ว": 140,
 "กต่": 140,
 "อเจ": 140,
 "เสน": 140,
 "ลยอ": 140,
 "่อต": 140,
 "์แล": 140,
 "ขาไ": 140,
 "าแพ": 140,
 "้าโ": 140,
 "ดคว": 140,
 "ู่ก": 140,
 "รได": 140,
 "ามว": 140,
 "เด่": 140,
 "บเบ": 139,
 "้ผิ": 139,
 "ับล": 139,
 "ักร": 139,
 "ิจา": 139,
 "อยไ": 139,
 "ะหม": 139,
 "่าป": 139,
 "ัวท": 139,
 "เว้": 139,
 "ยใช": 139,
 "็นผ": 139,
 "ุกก": 139,
 "ะคุ": 139,
 "นจร": 139,
 "่งจ": 139,
 "บคน": 139,
 "มาพ": 139,
 "วยไ": 139,
 "ยดเ": 138,
 "งั้": 138,
 "้วท": 138,
 "มเม": 138,
 "แกร": 138,
 "อรั": 138,
 "ปรี": 138,
 "หลุ": 138,
 "งละ": 138,
 "ธาน": 138,
 "แนว": 138,
 "างต": 138,
 "ะว่": 138,
 "จมา": 138,
 "วน์": 138,
  "่ถ้": 138,
 "ยุ่": 138,
 "วงเ": 138,
  "่น้": 137,
 "รกิ": 137,
 "ลเล": 137,
 "นำเ": 137,
 "าร้": 137,
 "าจจ": 137,
  "งยั": 137,
 "อาด": 137,
 "รมด": 137,
 "ังอ": 137,
 "าก่": 137,
 "ฉัน": 137,
  "งสำ": 137,
 "ีเจ": 137,
 "่ละ": 137,
 "ะยะ": 137,
 "นไข": 136,
 "ะดว": 136,
 "านจ": 136,
 "ระป": 136,
 "าแต": 136,
 "้วห": 136,
 "มเส": 136,
 "าลก": 136,
  "อไห": 136,
 "มชา": 136,
 "บื่": 136,
  "ะดู": 136,
 "่ยั": 136,
 "ลาเ": 136,
 "าลอ": 136,
 "งไร": 136,
 "ดีข": 136,
  "ในส": 135,
 "ะให": 135,
 "ในช": 135,
 "ามช": 135,
 "แม็": 135,
 "ัญญ": 135,
 "่วโ": 135,
 "ักแ": 135,
  "ต่ถ": 135,
 "มอน": 135,
 "้าช": 135,
 "์กั": 135,
 "วีอ": 135,
 "ามป": 135,
 "่อแ": 135,
 "งรอ": 135,
 "บอล": 135,
 "กเว": 135,
 "ี้ส": 135,
 "จำห": 135,
 "กาส": 135,
 "บน้": 135,
 "ยกร": 135,
 "มงา": 135,
 "ช้ส": 134,
 "สตร": 134,
 "อเส": 134,
 "หนอ": 134,
 "ัญช": 134,
 "นุน": 134,
 "ขออ": 134,
 "สรร": 134,
 "นน่": 134,
 "นถึ": 134,
 "ว่น": 134,
 "ในห": 134,
 "้อร": 134,
 "เฟร": 134,
  "ม.ย": 134,
 "ังว": 134,
 "งโต": 134,
 "วเร": 134,
 "ดขึ": 134,
 "ะใช": 134,
 "อเช": 134,
 "านร": 134,
 "จัย": 133,
 "รถส": 133,
  "งเว": 133,
 "ู่น": 133,
  "ิดจ": 133,
 "่งช": 133,
 "ซึม": 133,
 "็นโ": 133,
 "ัดน": 133,
 "ดวก": 133,
  "ดรา": 133,
 "งไท": 133,
  "นมะ": 133,
 "นภา": 133,
 "นโด": 133,
 "ีไม": 133,
 "สเม": 133,
 "้คน": 133,
 "กมั": 133,
 "ีกแ": 132,
 "ายจ": 132,
 "นอง": 132,
 "ามน": 132,
 "นเซ": 132,
 "ในท": 132,
  "ร่ค": 132,
   "ยด้": 132,
 "วเห": 132,
 "มีย": 132,
 "้เข": 132,
 "านิ": 132,
 "คตร": 132,
  "นรู": 132,
   "ร์จ": 132,
 "รออ": 131,
 "่าพ": 131,
 "ักม": 131,
 "ต่พ": 131,
 "กูเ": 131,
  "พอด": 131,
 "มีด": 131,
 "ไปล": 131,
 "ังแ": 131,
  "รั่": 131,
 "ปาย": 131,
 "ต่แ": 131,
 "ูมิ": 131,
 "าวก": 130,
  "มผั": 130,
 "ีเล": 130,
 "ุฟเ": 130,
 "จิต": 130,
 "นอฟ": 130,
 "นก่": 130,
  "ไปป": 130,
 "ับจ": 130,
 "าทั": 130,
 "ัยแ": 130,
 "ีกค": 130,
 "ิกเ": 130,
 "วว่": 130,
 "หนด": 129,
 "อจะ": 129,
 "วอย": 129,
 "ับว": 129,
  "เสม": 129,
 "ักท": 129,
 "บรอ": 129,
 "ยบเ": 129,
 "ี้ต": 129,
 "ะหน": 129,
 "่มอ": 129,
 "้เค": 129,
 "ชนะ": 129,
 "่นค": 129,
 "ดค่": 129,
 "มหน": 129,
 "หมี": 129,
 "้งพ": 129,
 "าไท": 128,
 "ยเพ": 128,
  "ใจค": 128,
 "งี้": 128,
 "อเท": 128,
 "เล้": 128,
 "่ช่": 128,
 "ินใ": 128,
 "านล": 128,
 "ือม": 128,
 "มปร": 128,
 "เอฟ": 128,
 "มคะ": 128,
 "รใช": 128,
  "ะสม": 128,
 "าแด": 127,
 "วัต": 127,
 "ชร์": 127,
 "้ขอ": 127,
  "่นด": 127,
  "เปอ": 127,
 "าพั": 127,
  "นธ์": 127,
 "ปซื": 127,
 "่มต": 127,
 "หลี": 127,
 "ุดใ": 127,
 "ยจ้": 127,
 "งชา": 127,
 "บร้": 127,
 "น์เ": 127,
 "อกใ": 127,
 "ัสด": 127,
 "็ต้": 126,
  "ุณเ": 126,
 "ิลป": 126,
 "ทิ้": 126,
 "ดเป": 126,
 "ทรง": 126,
 "่เส": 126,
 "ร์ก": 126,
 "บเป": 126,
 "จิ้": 126,
 "ิมเ": 126,
 "บขี": 126,
 "ช้ค": 126,
   "้อป": 126,
 "เย่": 126,
 "่ติ": 126,
 "รมี": 126,
 "่อผ": 126,
 "ยตั": 126,
  "ลยไ": 126,
 "บเส": 126,
 "้นใ": 126,
 "ศิล": 126,
 "วมส": 126,
 "ิดถ": 126,
  "ลาซ": 125,
 "าดไ": 125,
 "่ยม": 125,
  "ือว": 125,
 "กรั": 125,
  "ปีน": 125,
 "นล้": 125,
 "ใจม": 125,
 "าบิ": 125,
  "ันโ": 125,
 "ีกอ": 125,
 "จูน": 125,
 "ูไม": 125,
 "ไม้": 125,
 "ัมผ": 125,
  "จิง": 125,
  "งอี": 125,
 "มภา": 125,
 "านย": 125,
  "อแล": 124,
 "่เด": 124,
 "มกล": 124,
 "อนล": 124,
 "ใจจ": 124,
 "่นะ": 124,
 "ชัย": 124,
  "้หร": 124,
 "นช้": 124,
 "ช้ก": 124,
 "ีกเ": 124,
 "ารพ": 124,
 "เจน": 124,
 "ัวอ": 124,
 "ะสบ": 124,
  "าสต": 124,
 "ยเร": 124,
 "สีเ": 124,
 "ปดู": 124,
  "าวว": 124,
 "ดีน": 124,
 "้ทำ": 124,
 "ผัส": 124,
 "ีขา": 124,
 "์แบ": 124,
 "กน้": 124,
 "อดข": 124,
 "าบ้": 123,
 "ยน้": 123,
 "าะม": 123,
 "นแน": 123,
 "่าข": 123,
 "่ตอ": 123,
 "ลงเ": 123,
 "เจ็": 123,
 "งหา": 123,
 "อน้": 123,
 "ออเ": 123,
 "้งว": 123,
    "ชิญ": 123,
 "อบม": 123,
 "ย์เ": 123,
 "กนะ": 123,
 "ว้น": 123,
 "บให": 123,
 "ีขึ": 123,
 "้หน": 123,
 "้อห": 123,
 "าถึ": 123,
 "ักค": 123,
 "คที": 123,
 "ีมก": 123,
 "างช": 123,
 "สู่": 122,
 "ปไห": 122,
 "นิเ": 122,
 "ม่า": 122,
 "ต่ร": 122,
 "คนล": 122,
 "อนุ": 122,
 "คุย": 122,
 "แชร": 122,
 "้กล": 122,
  "ช็ค": 122,
 "อ้ย": 122,
  "งเย": 122,
 "จะข": 122,
 "สภา": 122,
 "่มค": 122,
 "เออ": 122,
 "าหร": 122,
 "ต่ล": 122,
 "กใจ": 122,
 "ปกป": 122,
 "มเด": 122,
 "อบั": 121,
 "ปเท": 121,
 "นอ่": 121,
 "รเม": 121,
 "จีน": 121,
 "งโร": 121,
 "ยดา": 121,
 "านด": 121,
   "้คุ": 121,
  "ต่ส": 121,
 "ุบั": 121,
 "วดเ": 121,
 "วาย": 121,
 "ยภา": 121,
 "ู้ใ": 121,
 "รขอ": 121,
 "ดก็": 121,
 "าคต": 121,
 "ดนต": 120,
 "ลุด": 120,
  "่อท": 120,
 "ลยย": 120,
 "ี้ใ": 120,
 "นะจ": 120,
 "ุ้ง": 120,
 "เปน": 120,
 "มาม": 120,
 "เน็": 120,
 "ะทั": 120,
 "้บ้": 120,
 "ปีใ": 120,
 "ัดแ": 120,
 "อยส": 120,
 "ห้พ": 120,
 "ก็ด": 120,
 "ำเป": 120,
 "่ผ่": 119,
  "าจร": 119,
 "ะคว": 119,
 "ินล": 119,
 "สมเ": 119,
 "ครเ": 119,
  "อรถ": 119,
 "ป๋า": 119,
 "คริ": 119,
 "้ด้": 119,
 "มอบ": 119,
 "กาว": 119,
 "อมั": 119,
  "อยน": 119,
   "ิดใ": 119,
 "าลื": 119,
 "อบอ": 119,
 "ังป": 119,
 "นสม": 119,
 "จสอ": 119,
 "อสั": 119,
 "หนก": 119,
 "อยแ": 119,
 "แอร": 119,
 "กก็": 118,
 "ู่ห": 118,
  "เบิ": 118,
 "ิวแ": 118,
 "วัส": 118,
 "ัวร": 118,
 "นนึ": 118,
  "ิริ": 118,
 "ทำอ": 118,
  "อกค": 118,
 "ขี้": 118,
  "พย์": 118,
 "กแต": 118,
 "งส่": 118,
 "วรร": 118,
 "าระ": 118,
 "รมช": 118,
  "างล": 118,
 "มพร": 118,
   "สมร": 118,
 "ยจะ": 118,
 "ม่ย": 118,
 "์บี": 118,
 "ีตั": 118,
 "าเต": 118,
 "ี้ด": 117,
 "้อก": 117,
 "มษา": 117,
 "กขึ": 117,
 "าวั": 117,
 "หรู": 117,
 "ค่ไ": 117,
  "อนๆ": 117,
 "ดอร": 117,
 "คอั": 117,
 "ดกร": 117,
 "ากด": 117,
 "ู่ท": 117,
 "บกล": 117,
 "บล็": 117,
 "ต่ำ": 117,
 "น็ต": 117,
  "ล้ำ": 117,
 "ห้ล": 117,
 "เมษ": 117,
 "รถค": 117,
  "ิดป": 117,
 "ปัจ": 117,
 "ำได": 117,
 "ำมา": 117,
 "งหั": 117,
 "สิต": 117,
 "ยหร": 117,
 "มคอ": 117,
 "าน้": 117,
 "ยมั": 117,
  "งคั": 116,
 "อีเ": 116,
 "ัจจ": 116,
 "าะส": 116,
 "ช้ม": 116,
 "ห้ง": 116,
   "มี่": 116,
 "ิตซ": 116,
 "าเม": 116,
 "นแส": 116,
 "นดู": 116,
 "ละต": 116,
 "ด้ย": 116,
 "ตัน": 116,
 "ๆกั": 116,
 "วนส": 116,
 "ว่ะ": 116,
 "้คว": 116,
 "์ใน": 116,
 "กลม": 116,
 "้อี": 116,
 "ันบ": 116,
 "พงก": 116,
 "งส์": 116,
 "นิค": 116,
 "ัวก": 115,
 "าเย": 115,
 "งื่": 115,
   "งขา": 115,
 "ารน": 115,
 "รถต": 115,
 "อเด": 115,
 "รงง": 115,
 "ารว": 115,
 "ทีน": 115,
 "ลอก": 115,
 "ูเป": 115,
 "สีแ": 115,
 "าเซ": 115,
 "ยเอ": 115,
 "ต่ท": 115,
 "อวา": 115,
 "ึงส": 115,
 "่เจ": 115,
 "#เล": 115,
 "สำน": 115,
 "วได": 115,
 "จ๊ะ": 115,
 "สะอ": 115,
 "ม่โ": 115,
 "อบท": 115,
 "ะขอ": 115,
 "สาน": 115,
 "ุดย": 115,
 "ยาธ": 114,
 "ะปร": 114,
 "มีจ": 114,
  "ามต": 114,
 "ยวน": 114,
 "บเท": 114,
 "ปได": 114,
 "ขั้": 114,
 "าสิ": 114,
 "่คิ": 114,
 "กต้": 114,
 "รคร": 114,
 "งช่": 114,
 "งยน": 114,
 "่มน": 114,
 "จำเ": 114,
 "ละน": 114,
  "ดาย": 114,
 "นือ": 114,
 "บบส": 114,
 "วรอ": 114,
 "งพร": 114,
 "กูก": 114,
 "ู้บ": 114,
 "้เท": 114,
 "่หา": 113,
 "้ต้": 113,
 "จาร": 113,
 "ยเด": 113,
 "กมี": 113,
  "ือต": 113,
 "สฟร": 113,
 "นหา": 113,
  "กเอ": 113,
 "ากบ": 113,
 "ไกล": 113,
 "ยแต": 113,
  "วมั": 113,
 "ห่า": 113,
  "บกิ": 113,
 "ไรไ": 113,
 "้ำแ": 113,
 "ีนา": 113,
 "ะเข": 113,
 "้ำต": 113,
 "ีกล": 113,
 "ันข": 112,
 "แห้": 112,
 "นสู": 112,
 "อกห": 112,
 "ำนั": 112,
  "ออะ": 112,
 "์ตี": 112,
 "รถม": 112,
 "ิทย": 112,
 "้ปร": 112,
 "ๆที": 112,
 "งคม": 112,
 "วงน": 112,
 "่เม": 112,
 "ต่ข": 112,
 "รัม": 112,
 "ุดค": 112,
 "ินจ": 112,
  "ิงเ": 111,
 "ะออ": 111,
 "ัดม": 111,
 "้อส": 111,
 "กร้": 111,
 "ากว": 111,
 "รขั": 111,
 "กรถ": 111,
 "รัช": 111,
 "ยงร": 111,
 "้สั": 111,
 "สนั": 111,
 "ยสา": 111,
 "มูก": 111,
 "รแพ": 111,
 "ีโป": 111,
  "คงไ": 111,
 "รวย": 111,
  "่มแ": 111,
 "ูนเ": 111,
 "วิน": 111,
 "องๆ": 111,
 "บสา": 111,
 "บพร": 111,
 "ดี้": 110,
 "กอน": 110,
 "มดแ": 110,
 "สิ้": 110,
 "จนเ": 110,
 "ตซู": 110,
 "อาง": 110,
 "มีม": 110,
 "ุณค": 110,
 "ๆเล": 110,
  "ะพา": 110,
 "็นว": 110,
 "ตให": 110,
   "่ขา": 109,
   "ระแ": 109,
  "ู้ห": 109,
 "ะลอ": 109,
   "งทั": 109,
 "อยอ": 109,
 "างบ": 109,
  "้คื": 109,
 "าเน": 109,
 "ดหม": 109,
 "จะช": 109,
 "ีกั": 109,
 "ยนี": 109,
 "ู้ช": 109,
 "ามจ": 109,
 "ดรถ": 109,
 "่ถู": 109,
 "ธัน": 109,
  "ก็ร": 109,
}
